module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('md-sidenav', {
    ref: "worknoteSidenav",
    staticClass: "md-right worknote-side-nav",
    on: {
      "open": function($event) {
        return _vm.open()
      },
      "close": function($event) {
        return _vm.close()
      }
    }
  }, [_c('md-toolbar', {
    staticClass: "worknote-side-nav-toolbar main-toolbar"
  }, [_c('div', {
    staticClass: "worknote-side-nav-toolbar-labels"
  }, [(_vm.isSwitchedArchive) ? _c('p', [_vm._v("Work Note Archive")]) : _c('p', [_vm._v("Current Work Notes")]), _vm._v(" "), (_vm.isSwitchedArchive) ? _c('span', [_vm._v("Found: " + _vm._s(_vm.getUnArchivedNotesCount))]) : _c('span', [_vm._v("Found: " + _vm._s(_vm.getCurrentWorkNotes.length))])]), _vm._v(" "), _c('md-button', {
    staticClass: "btn-close-worknote-sidenav md-icon-button md-fab md-clean md-mini",
    on: {
      "click": _vm.closeWorkNoteNav
    }
  }, [_c('md-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('md-list', {
    staticClass: "worknote-side-nav-items-list"
  }, [_c('div', {
    staticClass: "switch-mode-link"
  }, [_c('md-button', {
    staticClass: "md-raised",
    on: {
      "click": _vm.exportList
    }
  }, [_vm._v("Export")]), _vm._v(" "), (_vm.isSwitchedArchive) ? _c('div', {
    on: {
      "click": _vm.changeViewMode
    }
  }, [_c('md-icon', [_vm._v("unarchive")]), _vm._v(" "), _c('span', [_vm._v("View Current Work Notes")])], 1) : _c('div', {
    on: {
      "click": _vm.changeViewMode
    }
  }, [_c('md-icon', [_vm._v("move_to_inbox")]), _vm._v(" "), _c('span', [_vm._v("View Work Note Archive")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "list-view-visible-layers"
  }, [_c('strong', {
    staticStyle: {
      "margin-right": "1rem"
    }
  }, [_vm._v("Visible Layers:")]), _vm._v(" "), _vm._l((_vm.layers), function(layer) {
    return _c('md-checkbox', {
      key: layer.id,
      staticStyle: {
        "margin-right": "1rem"
      },
      attrs: {
        "value": _vm.visibleListLayerIDs.includes(layer.id)
      },
      on: {
        "change": function (val) { return _vm.changeVisibleListLayer(layer.id, val); }
      }
    }, [_vm._v("\n                    " + _vm._s(layer.title) + "\n                ")])
  })], 2), _vm._v(" "), (!_vm.isSwitchedArchive) ? _c('div', _vm._l((_vm.groupedByUnArchivedPages), function(item, index) {
    return _c('div', {
      key: item.data.editedAt + '' + index
    }, [(item.type === 'page' && _vm.getCurrentWorkNotes.length > 0) ? _c('md-list-item', {
      staticClass: "worknote-item-page",
      attrs: {
        "disabled": item.type === 'page'
      }
    }, [_vm._v("\n                            Page " + _vm._s(_vm.project.pdfPageNumbers && _vm.project.pdfPageNumbers[item.data.pageNumber - 1] &&
      _vm.project.pdfPageNumbers[item.data.pageNumber - 1].name && _vm.project.pdfPageNumbers[item.data.pageNumber - 1].name) + "\n                        ")]) : _vm._e(), _vm._v(" "), (item.type === 'layer' && _vm.visibleListLayerIDs.includes(item.data.layer)) ? _c('md-list-item', {
      staticClass: "worknote-item-layer",
      staticStyle: {
        "border-bottom": "0"
      }
    }, [_vm._v("\n                            " + _vm._s(_vm.splicePageNumber(item.data)) + "\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.visibleListLayerIDs.includes(item.data.layer)) ? _c('div', [(item.type === 'cue' && !item.data.archived) ? _c('md-list-item', {
      key: item.data.id,
      staticClass: "worknote-item-cue",
      class: {
        'selectedCue': item.data.id === _vm.focusedCueId
      },
      on: {
        "click": function($event) {
          return _vm.gotoCue(item.data)
        }
      }
    }, [_c('md-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.data.id === _vm.focusedCueId),
        expression: "item.data.id === focusedCueId"
      }]
    }, [_vm._v("arrow_right")]), _vm._v(" "), _c('div', {
      staticClass: "worknote-item-cue-info"
    }, [_c('div', {
      staticClass: "worknote-item-cue-info-body"
    }, [_c('span', {
      staticClass: "worknote-item-cue-info-desc"
    }, [_vm._v(_vm._s(item.data.workNote))]), _vm._v(" "), _c('span', {
      staticClass: "worknote-item-cue-info-date",
      staticStyle: {
        "padding-top": "0"
      }
    }, [_vm._v("\n                                            " + _vm._s(_vm.getEditedDateTime(item.data)) + "\n                                            "), (_vm.editable(item.data) && !_vm.isSwitchedArchive) ? _c('md-button', {
      staticClass: "md-icon-button btn-archive-cue",
      on: {
        "click": function($event) {
          return _vm.archiveWorkNoteCue(item.data, $event)
        }
      }
    }, [_c('md-icon', [_vm._v("move_to_inbox")]), _vm._v(" "), _c('md-tooltip', {
      attrs: {
        "md-direction": "top"
      }
    }, [_vm._v("Archive note")])], 1) : _vm._e()], 1)])])], 1) : _vm._e()], 1) : _vm._e()], 1)
  }), 0) : _vm._e(), _vm._v(" "), (_vm.isSwitchedArchive) ? _c('div', _vm._l((_vm.groupedByArchivedPages), function(item, index) {
    return _c('div', {
      key: item.data.editedAt + '' + index
    }, [(item.type === 'page' && _vm.getUnArchivedNotesCount > 0) ? _c('md-list-item', {
      staticClass: "worknote-item-page",
      attrs: {
        "disabled": item.type === 'page'
      }
    }, [_vm._v("\n                            Page " + _vm._s(_vm.project.pdfPageNumbers && _vm.project.pdfPageNumbers[item.data.pageNumber - 1] &&
      _vm.project.pdfPageNumbers[item.data.pageNumber - 1].name && _vm.project.pdfPageNumbers[item.data.pageNumber - 1].name) + "\n                        ")]) : _vm._e(), _vm._v(" "), (item.type === 'layer' && _vm.visibleListLayerIDs.includes(item.data.layer)) ? _c('md-list-item', {
      staticClass: "worknote-item-layer",
      staticStyle: {
        "border-bottom": "0"
      }
    }, [_vm._v("\n                            " + _vm._s(_vm.splicePageNumber(item.data)) + "\n                        ")]) : _vm._e(), _vm._v(" "), (item.type === 'cue' && item.data.archived && _vm.visibleListLayerIDs.includes(item.data.layer)) ? _c('md-list-item', {
      key: item.data.editedAt,
      staticClass: "worknote-item-cue",
      class: {
        'selectedCue': item.data.editedAt === _vm.focusedCueEditedAt
      },
      on: {
        "click": function($event) {
          return _vm.gotoCue(item.data)
        }
      }
    }, [_c('md-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.data.editedAt === _vm.focusedCueEditedAt),
        expression: "item.data.editedAt === focusedCueEditedAt"
      }]
    }, [_vm._v("arrow_right")]), _vm._v(" "), _c('div', {
      staticClass: "worknote-item-cue-info"
    }, [_c('div', {
      staticClass: "worknote-item-cue-info-body"
    }, [_c('span', {
      staticClass: "worknote-item-cue-info-desc"
    }, [_vm._v(_vm._s(item.data.workNote))]), _vm._v(" "), _c('span', {
      staticClass: "worknote-item-cue-info-date",
      staticStyle: {
        "padding-top": "0'"
      }
    }, [_vm._v("\n                                        " + _vm._s(_vm.getEditedDateTime(item.data)) + "\n                                        "), (_vm.editable(item.data)) ? _c('md-button', {
      staticClass: "md-icon-button btn-archive-cue",
      on: {
        "click": function($event) {
          return _vm.unArchiveWorkNoteCue(item, $event)
        }
      }
    }, [_c('md-icon', [_vm._v("unarchive")]), _vm._v(" "), _c('md-tooltip', {
      attrs: {
        "md-direction": "left"
      }
    }, [_vm._v("Restore as the current note. Any current note on this cue is archived, not deleted.")])], 1) : _vm._e(), _vm._v(" "), (_vm.editable(item.data)) ? _c('md-button', {
      staticClass: "md-icon-button btn-archive-cue",
      on: {
        "click": function($event) {
          return _vm.removeArchivedNote(item, $event)
        }
      }
    }, [_c('md-icon', [_vm._v("delete")]), _vm._v(" "), _c('md-tooltip', {
      attrs: {
        "md-direction": "left"
      }
    }, [_vm._v("Permanently delete this note.")])], 1) : _vm._e()], 1)])])], 1) : _vm._e()], 1)
  }), 0) : _vm._e()])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-197f792a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/project/worknote/nav.vue
// module id = 1208
// module chunks = 21